import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDate } from '../../../redux/Appointment/AppointmentAction';
import { makeStyles, Tooltip } from '@material-ui/core';
import { jalaaliDaysOfWeek, getDay, milaadiDaysOfWeek } from '../../../utils/dateTimeUtil';
import ARROW_ICON from '../../../assets/images/blue_arrow.png';
import moment from 'moment-jalaali';
import { useHistory, useLocation } from 'react-router-dom';
import LanguageContext from '../../../contexts/languageContext';
const styles = makeStyles({
    header: {
        padding: '18px 20px',
        boxShadow: '0 2px 24px 0 rgba(0, 0, 0, 0.06)'
    },
    weekTitle: {
        display: 'flex',
        paddingRight: (props) => (props.rtl ? '80px' : '7px'),
        paddingLeft: (props) => (props.rtl ? '7px' : '80px'),
        position: 'relative',
        lineHeight: '2em',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)'
    },
    weekOption: {
        display: 'flex',
        fontSize: '18px'
    },
    day: {
        width: '14%',
        textAlign: 'center',
        fontSize: '16px',
        position: 'relative',
        paddingTop: '3px',
        paddingBottom: '4px',
        '&:hover': {
            cursor: 'pointer',
            color: '#1b90fa'
        }
    },
    selectedDay: {
        color: '#1b90fa'
    },
    weekIconPrev: {
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        position: 'absolute',
        right: (props) => (props.rtl ? '0' : 'auto'),
        left: (props) => (props.rtl ? 'auto' : '0'),
        top: '0',
        bottom: '0',
        zIndex: '11',
        transform: (props) => (props.rtl ? 'none' : 'rotate(180deg)')
    },
    weekIconNext: {
        padding: '0 16px',
        position: 'absolute',
        left: (props) => (props.rtl ? '0' : 'auto'),
        right: (props) => (props.rtl ? 'auto' : '0'),
        top: '0',
        bottom: '0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '11',
        transform: (props) => (props.rtl ? 'rotate(180deg)' : 'none')
    },
    yearNMonth: {
        textAlign: 'center',
        display: 'flex',
        flexFlow: 'row-reverse',
        justifyContent: 'center',
        alignItems: 'center'
    },
    month: {
        fontWeight: '800',
        paddingLeft: '5px'
    },
    date: {
        fontWeight: '800',
        lineHeight: '1.72',
        fontSize: '18px'
    },
    weekDay: {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '1.69'
    }
});
const CalendarHeader = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const week = useSelector((state) => state.appointment?.date?.week);
    const date = useSelector((state) => state.appointment?.date?.selected);
    const { pathname } = useLocation();
    const clinicId = pathname?.split('/').filter((item) => item)[0];
    function goPrevWeek() {
        const newDate = moment(date).subtract(7, 'days').format('YYYY-MM-DD');
        dispatch(setDate(newDate));
    }
    function goNextWeek() {
        const newDate = moment(date).add(7, 'days').format('YYYY-MM-DD');
        dispatch(setDate(newDate));
    }
    const goToRelatedDnDView = (date) => {
        const validDate = moment(date).format('YYYY-MM-DD');
        dispatch(setDate(validDate));
        history.push(`/${clinicId}/appointment/day`);
    };

    return (
        <>
            {/* <div className={classes.header}>
                    <div className={classes.weekOption}>

                        <div className={classes.yearNMonth}>
                            <div className={classes.year}>{getFullYear(date)}</div>
                            <div className={classes.month}>{getPersianMonthName(date)} </div>
                        </div>

                    </div>
                </div> */}
            <div className={classes.weekTitle}>
                <div className={classes.weekIconPrev} onClick={() => goPrevWeek()}>
                    <Tooltip title="Previous Week">
                        <img width={25} src={ARROW_ICON} alt="next-week" />
                    </Tooltip>
                </div>

                <div className={classes.weekIconNext} onClick={() => goNextWeek()}>
                    <Tooltip title="Next Week">
                        <img width={25} src={ARROW_ICON} alt="prev-week" />
                    </Tooltip>
                </div>
                {(lang === 'fa' ? jalaaliDaysOfWeek : milaadiDaysOfWeek).map((day, index) => (
                    <div
                        className={`${classes.day} ${
                            getDay(week[day.index]) === getDay(date) ? classes.selectedDay : ''
                        }`}
                        key={index}
                        onClick={() => goToRelatedDnDView(week[day.index])}
                    >
                        <div className={classes.date}>{getDay(week[day.index])}</div>
                        <div className={classes.weekDay}>{day.label}</div>
                        {/* <div
                                className={
                                    getDay(this.props.week[index]) === getDay(this.props.date)
                                        ? classes.selectedDay
                                        : ''
                                }
                            ></div> */}
                    </div>
                ))}
            </div>
        </>
    );
};

export default CalendarHeader;
